var styleDataHash = "56f095bc";
const injectCss = () => {
  var css = `.U-tyo,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.LQ3sW{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .LQ3sW{background-color:#fff}.LQ3sW.MAllU{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LQ3sW{height:47px}}}@container (width < 640px){.LQ3sW{height:47px}}.LQ3sW ._7Opra{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;grid-gap:12px}[dir=ltr] .LQ3sW ._7Opra,[dir=rtl] .LQ3sW ._7Opra{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LQ3sW ._7Opra.wqySg{grid-auto-columns:auto}}}@container (width < 640px){.LQ3sW ._7Opra.wqySg{grid-auto-columns:auto}}.LQ3sW ._7Opra .o8UL2{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LQ3sW ._7Opra .o8UL2{display:flex;width:100%}}}@container (width < 640px){.LQ3sW ._7Opra .o8UL2{display:flex;width:100%}}.LQ3sW ._7Opra .CR2YS{display:grid;grid-auto-flow:row}.LQ3sW ._7Opra .CR2YS .ysqdN{font-size:14px}.LQ3sW ._7Opra .CR2YS .vT9sC{color:#646464;font-size:12px}.LQ3sW ._7Opra .JQQF0{align-self:right}.LQ3sW:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.LQ3sW.MAllU,.LQ3sW:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .LQ3sW.MAllU,[dir] .LQ3sW:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.LQ3sW.MAllU svg,.LQ3sW:active svg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .LQ3sW:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "U-tyo",
  "container": "LQ3sW",
  "selected": "MAllU",
  "content": "_7Opra",
  "content_mobile_alignCenter": "wqySg",
  "prefix": "o8UL2",
  "titleWrapper": "CR2YS",
  "title": "ysqdN",
  "subtitle": "vT9sC",
  "suffix": "JQQF0"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
